module.exports = __webpack_public_path__ + "img/base_activites_trail.22cd3c0e.svg";